namespace TabAurous.OMS {
    export namespace ProductMasterService {
        export const baseUrl = 'OMS/ProductMaster';

        export declare function Create(request: Serenity.SaveRequest<ProductMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AllProductsList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function OldExcelImport(request: ExcelImportRequest, onSuccess?: (response: Common.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: ExcelImportRequest, onSuccess?: (response: Common.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductEnquiry(request: ProductRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductsEnquiry(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function OrdersBulkAction(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductImages(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProductMaster/Create",
            Update = "OMS/ProductMaster/Update",
            Delete = "OMS/ProductMaster/Delete",
            Retrieve = "OMS/ProductMaster/Retrieve",
            List = "OMS/ProductMaster/List",
            CustomList = "OMS/ProductMaster/CustomList",
            AllProductsList = "OMS/ProductMaster/AllProductsList",
            OldExcelImport = "OMS/ProductMaster/OldExcelImport",
            ExcelImport = "OMS/ProductMaster/ExcelImport",
            ProductEnquiry = "OMS/ProductMaster/ProductEnquiry",
            ProductsEnquiry = "OMS/ProductMaster/ProductsEnquiry",
            OrdersBulkAction = "OMS/ProductMaster/OrdersBulkAction",
            GetProductImages = "OMS/ProductMaster/GetProductImages"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'AllProductsList', 
            'OldExcelImport', 
            'ExcelImport', 
            'ProductEnquiry', 
            'ProductsEnquiry', 
            'OrdersBulkAction', 
            'GetProductImages'
        ].forEach(x => {
            (<any>ProductMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
